import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  LayoutDashboard,
  Activity,
  Users,
  Trophy,
  Target,
  Award,
  Shield,
  UserCircle,
} from 'lucide-react';
import { cn } from '@/lib/cn';
import { ROUTES } from '@/app/routes';
import { useAuth } from '@/contexts/AuthContext';
import { UserMenu } from './UserMenu';

export function Sidebar() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const items = [
    { to: ROUTES.dashboard, label: t('nav.dashboard'), icon: LayoutDashboard, end: true },
    { to: ROUTES.activities, label: t('nav.activities'), icon: Activity, end: false },
    { to: ROUTES.friends, label: t('nav.friends'), icon: Users, end: false },
    { to: ROUTES.communities, label: t('nav.communities'), icon: UserCircle, end: false },
    { to: ROUTES.leaderboards, label: t('nav.leaderboards'), icon: Trophy, end: false },
    { to: ROUTES.challenges, label: t('nav.challenges'), icon: Target, end: false },
    { to: ROUTES.achievements, label: t('nav.achievements'), icon: Award, end: false },
    ...(user?.isAdmin
      ? [{ to: ROUTES.adminChallenges, label: t('nav.admin'), icon: Shield, end: false }]
      : []),
  ];

  return (
    <aside className="sticky top-0 flex h-[100dvh] w-60 shrink-0 flex-col border-r border-parchment-border bg-parchment p-4">
      <Link to={ROUTES.dashboard} className="mb-6 inline-flex items-center gap-2">
        <span className="grid h-9 w-9 place-items-center rounded-lg bg-accent text-parchment-light shadow-parchment-card">
          <Flame />
        </span>
        <span className="font-display text-2xl text-parchment-ink">Ember</span>
      </Link>
      <nav className="flex flex-col gap-0.5" aria-label="Primary">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-parchment-dark text-parchment-ink'
                  : 'text-parchment-muted hover:bg-parchment-dark/50 hover:text-parchment-ink',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="mt-auto">
        <UserMenu />
      </div>
    </aside>
  );
}

function Flame() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2c1.5 4 5 5.5 5 10a5 5 0 11-10 0c0-3 1.5-5 3-7 .8 1.5.5 3 2 5 0-3 0-5 0-8z" />
    </svg>
  );
}
